import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import {Header, Titulo} from '../elementos/Header'
import BtnRegresar from '../elementos/BtnRegresar'
import FormularioObjeto from './FormularioObjeto'
import favicon from '../imagenes/logoutm.png'

const RegistroObjeto = () => {
    return (
        <>
            <HelmetProvider>
                <div>
                    <Helmet>
                        <link rel="shortcut icon" href={favicon} type="image/x-con"/>
                        <title>Registro de Objeto</title>
                    </Helmet>
                </div>
            </HelmetProvider>

            <Header>
                    <Titulo>Registro de Objeto</Titulo>
                    <BtnRegresar ruta="/objetos"/>
            </Header>

            <FormularioObjeto />
        </>
    );
}
 
export default RegistroObjeto;